module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/california-db0186e8faa9dc1e23c9abd3ded4bd29.jpg";